module.exports = __webpack_public_path__ + "img/feature_buy_id.440a1dcb.png";